let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f0bHg")).then(() => parcelRequire('3lq3e'));